import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import FeedPage from "@/pages/FeedPage";
import ArchivePage from "@/pages/ArchivePage";
import StoryDetailPage from "@/pages/StoryDetailPage";
import BookmarksPage from "@/pages/BookmarksPage";
import TopicsPage from "@/pages/TopicsPage";
import TopicDetailPage from "@/pages/TopicDetailPage";
import DisagreementPage from "@/pages/DisagreementPage";
import { LoginPage, RegisterPage } from "@/pages/AuthPages";

function Layout({ children }) {
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <footer className="border-t border-stone-300 mt-10 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap items-center justify-between gap-3 font-mono-head text-[10px] uppercase tracking-[0.3em] text-stone-500">
          <span>© Hot Truth Archive · Open Investigation</span>
          <span>// Alternative angles are speculative · Always verify with primary sources</span>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/" element={<Layout><FeedPage /></Layout>} />
          <Route path="/topics" element={<Layout><TopicsPage /></Layout>} />
          <Route path="/topics/:id" element={<Layout><TopicDetailPage /></Layout>} />
          <Route path="/disagreement" element={<Layout><DisagreementPage /></Layout>} />
          <Route path="/archive" element={<Layout><ArchivePage /></Layout>} />
          <Route path="/story/:id" element={<Layout><StoryDetailPage /></Layout>} />
          <Route path="/bookmarks" element={<Layout><BookmarksPage /></Layout>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
